import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {HinweisboxTypeEnum} from "../../../shared/components/hinweisbox/hinweisbox-type.enum";
import {HinweisboxComponent} from "../../../shared/components/hinweisbox/hinweisbox.component";
import {I18NextPipe} from "@kokos-i18next";
import {ErrorType} from "./error-types";
import {ErrorMessageService} from "../../../core/services/error-message.service";
import i18next from "i18next";

@Component({
    selector: 'kokos-errorbox',
    imports: [
        HinweisboxComponent,
      I18NextPipe
    ],
  templateUrl: './errorbox.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ErrorboxComponent {


  protected readonly HinweisboxTypeEnum = HinweisboxTypeEnum;

  @Input() errorType: ErrorType;
  @Input() errorCode: string;

  private readonly errorMessageService = inject(ErrorMessageService);

  protected readonly ErrorType = ErrorType;


  get validationErrorText():string{
      return this.errorCode ? i18next.t(this.errorMessageService.getFfpErrorKey(this.errorCode).detail) : null;
  }

}
